import { render, staticRenderFns } from "./AlertsByDevice.vue?vue&type=template&id=5ae5e387"
import script from "./AlertsByDevice.vue?vue&type=script&lang=js"
export * from "./AlertsByDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports